/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NotificationsEntityMail { 
    event_edit_or_cancel?: boolean;
    event_new_participant?: boolean;
    event_share?: boolean;
    event_participant_unregister?: boolean;
    event_confirm_register?: boolean;
    event_confirm_unregister?: boolean;
    group_invitation?: boolean;
    group_accept?: boolean;
    group_new_member?: boolean;
    marketing?: boolean;
}

